import { forwardRef, Module } from '@nestjs/common';
import { AuditModule } from '../audit/audit.module';
import { ContabilidadModule } from '../contabilidad/contabilidad.module';
import { PrismaModule } from '../prisma/prisma.module';
import { RendicionViaticosModule } from '../rendicion-viaticos/rendicion-viaticos.module';
import { ContabilidadConciliacionController } from './contabilidad-conciliacion.controller';
import { ContabilidadConciliacionService } from './contabilidad-conciliacion.service';

@Module({
  imports: [
    PrismaModule,
    AuditModule,
    ContabilidadModule,
    forwardRef(() => RendicionViaticosModule),
  ],
  controllers: [ContabilidadConciliacionController],
  providers: [ContabilidadConciliacionService],
  exports: [ContabilidadConciliacionService],
})
export class ContabilidadConciliacionModule {}
